import type { Renderer } from "../renderer";
import { DEFAULT_BIOCLAST } from "./bioclast";
import {
  resolveSceneValues,
  type ScenePreset,
  type SceneVariant,
} from "./scenePresets";

/** Apply a curated scene from a clean visual baseline. */
export function applyScenePreset(
  renderer: Renderer,
  scene: ScenePreset,
  variant: SceneVariant | null = null,
): void {
  const qualityTier = renderer.params.qualityTier;

  renderer.clearAltCameraOverride();
  renderer.modulations = {};
  Object.assign(
    renderer.params,
    DEFAULT_BIOCLAST,
    { qualityTier },
    resolveSceneValues(scene, variant),
  );
  renderer.sceneType = scene.sceneType ?? "bioclast";
  renderer.onScenePresetApplied();
  renderer.resetSceneState();
}